import { type ComponentProps, type ReactNode } from 'react';

interface IProps extends ComponentProps<'button'> {
  children: ReactNode;
}

function EditorButton(props: IProps) {
  return (
    <button
      className="text-foreground hover:bg-tertiary hover:text-background disabled:hover:text-foreground [&>svg]:size-5.5 flex cursor-pointer items-center justify-center rounded-md p-1 text-sm font-medium leading-none disabled:cursor-not-allowed disabled:opacity-50 disabled:hover:bg-transparent"
      type="button"
      {...props}
    />
  );
}

export default EditorButton;
